import { IEntryOrderReceivers, Types } from './types';
import { IShipToCustomerItem } from '../../../services/EntryOrder';

export type EntryOrderReceiverState = IEntryOrderReceivers | null;
const initialState: EntryOrderReceiverState = null;

export function entryOrderReceiversReducer(
  state: EntryOrderReceiverState = initialState,
  action: {
    type: Types;
    payload: { customerId: string; items: IShipToCustomerItem[] };
  }
): EntryOrderReceiverState {
  switch (action.type) {
    case Types.LOAD_RECEIVERS_LOADING: {
      return {
        receivers: [],
        loading: true,
        customerId: action.payload.customerId
      };
    }
    case Types.LOAD_RECEIVERS_SUCCESS: {
      return {
        receivers: action.payload.items,
        loading: false,
        customerId: action.payload.customerId
      };
    }
    default:
      return state;
  }
}
